<div *ngIf="inspectionService.inspection != null">
  <ng-container [ngSwitch]="inspectionService.inspection.reportType">
    <xsr-vcr-report-display *ngSwitchCase="'VCR'"></xsr-vcr-report-display>
  </ng-container>
</div>